import React from "react";
import { Box, Grid, Stack } from "@mui/material";
import "./Header.scss";
import puravankarLogo from "../../assets/icons/purva-logo-white.png";
import ProvidentLogo from "../../assets/images/Provident Reverse logo.png";
import PurvaLandLogo from "../../assets/images/PurvaLand Master Logo reverse.png";
import { useSelector } from "react-redux";
import { COMPARE_VALUE } from "../../config/constant";
const HeaderCustomerPreview = ({ title }) => {

  const { enquiryDetails } = useSelector(
    (state) => state.newBookingForm
  );

  const getBrandImage = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };

  return (
    <>
      <Stack
        sx={{
          backgroundColor: "#1A407D",
          position: "fixed",
          top: "0px",
          left: "0px",
          height: {
            xs: "60px",
            sm: "60px",
            md: "88px",
          },
          width: "100%",
          zIndex: 99,
          color: "#ffff",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          container
          spacing={0}
          className="headerPLeftRight"
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            height: "100%",
            paddingLeft: {
              xs: "16px",
              sm: "16px",
              md: "7%",
            },
            paddingRight: {
              xs: "16px",
              sm: "16px",
              md: "7%",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                fontSize: "22px",
                fontWeight: "500",
                textAlign: "center",
                display: {
                  xs: "none",
                  sm: "block",
                },
              }}
            >
              {title || 'Booking Application'}
            </Box>
            <Box
              sx={{
                width: { xs: "200px", sm: "200px", md: "276px" },
                height: { xs: "32px", sm: "32px", md: "32px" },
                display: "block",
                overflow: "hidden",
                textAlign: "right",

                position: {
                  xs: "relative",
                  sm: "absolute",
                },
                top: {
                  xs: "0px",
                  sm: "15px",
                  md: "30px",
                },
                right: "0",
              }}
            >
              {getBrandImage() ? (
                <img
                  src={getBrandImage()}
                  alt="Logo"
                  style={{
                    maxWidth: "100%",
                    height: "100%",
                    //objectFit: "contain",
                  }}
                />
              ) : null}
            </Box>
          </Box>
        </Grid>
      </Stack>
      <div className="extraHeight"></div>
    </>
  );
};

export default HeaderCustomerPreview;
